import { forwardRef, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import {
  resetForm,
  StockMovement,
  setStockMovementDialog,
} from "../../../../app/slices/stockMovementSlice";
import { Controller, useForm } from "react-hook-form";
import { SelectUser } from "../../../../components/Selectors/SelectUser";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StockMovementForm = (props) => {
  const _StockMovement = useSelector(
    (state) => state.stockMovement.stockMovement
  );
  const _SearchBody = useSelector((state) => state.stockMovement.searchBody);
  const _StockSearchBody = useSelector((state) => state.stock.searchBody);
  const _Stock = useSelector((state) => state.stock.stock);
  const _User = useSelector((state) => state.user.usersList.data);

  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: {},
  });
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    dispatch(
      StockMovement.create(
        {
          stock_id: _StockMovement.stock_id,
          description: data.description,
          count: data.count,
          date: data.date,
          user_id: data.user_id,
          is_in: props.isIn,
        },
        _SearchBody,
        _StockSearchBody
      )
    );
  };
  useEffect(() => {
    reset({ ..._Stock.form });
  }, [reset,_Stock.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, [dispatch]);


  const handleDialog = () => {
    dispatch(setStockMovementDialog(null));
  };

  return (
    <Dialog
      open={_StockMovement.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handleDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {props.isIn ? "أضافة " : "سحب"}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            {!props.isIn && (
              <Grid item xs={12} md={12}>
                <Controller
                  name="user_id"
                  control={control}
                  render={({ field }) => (
                    <SelectUser
                      {...field}
                      required
                      onChange={(e, newValue) => {
                        setValue("user_id", newValue ? newValue.id : null);
                      }}
                      value={
                        _User?.filter((x) => x.id === field.value)[0]
                          ? _User?.filter((x) => x.id === field.value)[0]
                          : null
                      }
                    />
                  )}
                />
              </Grid>
            )}
            <Grid item xs={12} md={12}>
              <Controller
                name="count"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="العدد"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="description"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="الوصف"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="date"
                control={control}
                render={({ field }) => (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      inputFormat="YYYY-MM-DD"
                      label="التاريخ"
                      value={field.value}
                      onChange={(e, newValue) => {
                        setValue("date", dayjs(e).format("YYYY-MM-DD"));
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          size="small"
                          fullWidth
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "يوم/شهر/سنة",
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button type="submit" variant="contained" color="primary">
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default StockMovementForm;
